import HttpService from 'domovio-core/src/system/rest/rest.service';

export async function loadSubscription(projectId) {
    return HttpService.get('/v1/subscriptions/last', { projectId });
}
